import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TOGGLE_WORKSPACE } from "../utils/hotkeys";
import { useWorkspaceModal } from "../contexts/WorkspaceModalContext";

const MAIN_PATH = "/main";

/**
 * Listens for Shift+W globally. On main page: toggles workspace modal.
 * On other pages: navigates to main and opens the workspace modal.
 */
function GlobalHotkeys() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isWorkspaceModalOpen, setWorkspaceModalOpen, requestCloseRef } = useWorkspaceModal();

  useEffect(() => {
    if (process.env.NODE_ENV === "production") return;
    const onKeyDown = (e) => {
      if (!TOGGLE_WORKSPACE.match(e)) return;
      const active = typeof document !== "undefined" ? document.activeElement : null;
      const tag = active?.tagName?.toLowerCase();
      if (tag === "input" || tag === "textarea" || active?.getAttribute("contenteditable") === "true") return;
      e.preventDefault();

      if (location.pathname !== MAIN_PATH) {
        navigate(MAIN_PATH, { state: { openWorkspaceModal: true } });
      } else if (isWorkspaceModalOpen) {
        requestCloseRef.current?.();
      } else {
        setWorkspaceModalOpen(true);
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [location.pathname, navigate, setWorkspaceModalOpen, isWorkspaceModalOpen, requestCloseRef]);

  return null;
}

export default GlobalHotkeys;
